import { Stroke, Style } from "ol/style";
import { extractTags } from "./propertyExtraction";

export function getHDMapStyleNormal(feature) {
  return getHDMapColorStyle(feature);
}
export function getHDMapStyleClick(feature) {
  return getHDMapColorStyle(feature, true, false);
}
export function getHDMapStyleHover(feature) {
  return getHDMapColorStyle(feature, false, true);
}
function getHDMapColorStyle(feature, click, hover) {
  let color, width, backgroundColor, backgroundWidth;

  const tags = extractTags(feature);
  let hdmapType = tags.hdMap;

  if (hdmapType !== undefined) {
    if (
      hdmapType !== "lane_center_line" &&
      hdmapType !== "lane_trajectory_line"
    ) {
      return;
    }
  }

  let type = feature.get("type");
  if (type === "ORBIS_RELATION") {
    return;
  }

  if (hdmapType === "lane_center_line") {
    color = "blue";
  } else if (hdmapType === "lane_trajectory_line") {
    color = "red";
  } else {
    color = "lightgreen";
  }

  backgroundColor = "white";
  width = 2;
  backgroundWidth = 4;
  if (hover || click) {
    return [
      new Style({
        stroke: new Stroke({
          color: color,
          width: width,
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: backgroundColor,
          width: backgroundWidth,
        }),
      }),
    ];
  }
  return [
    new Style({
      stroke: new Stroke({
        color: color,
        width: width,
      }),
    }),
  ];
}
